import {HttpHandler} from "../../../utils/handler/HttpHandler";

export class BilateralControlPanelService {
    constructor(){
        this.httpHandler = new HttpHandler();
        this.axiosInstance = this.httpHandler.createInstance('/bilateral');
    }

    getControlPanelLoanList(filters) {
        return this.axiosInstance({
            url: '/loan',
            method: 'get',
            params: filters
        }).then(res => res);
    }

}